var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgLogoWide = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 208,
    height: 50,
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "30 0 197.3 58.5",
    style: {
      enableBackground: "new 0 0 197.3 58.5"
    },
    xmlSpace: "preserve",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_00000049918730487876209070000001304336120938861197_);}\n\t.st2{fill:#FFFFFF;}\n")), /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -5347.2183,
    y1: 1284.5465,
    x2: -5320.5684,
    y2: 1312.8566,
    gradientTransform: "matrix(0.7043 0 0 0.7055 3787.6401 -883.0419)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D81F26"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BC2025"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M46.7,33l-9-21.5h-9.3l-14,32.7h25.4l-3-7.4h-9.5L33.2,23L42,44.2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000095313446229358291630000014483895705977336227_",
    gradientUnits: "userSpaceOnUse",
    x1: -5303.7646,
    y1: 1267.9672,
    x2: -5303.7646,
    y2: 1314.0771,
    gradientTransform: "matrix(0.7043 0 0 0.7055 3787.6401 -883.0419)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FECA72"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#EE841E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FECA72"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000095313446229358291630000014483895705977336227_)"
    },
    d: "M65,11.5H39.5l3.3,7.5h9.8L41.9,44.2h9.4 L65,11.5L65,11.5z"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M68.9,11.5h1.7v7.4h-1.7V11.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M74.1,14.4l3.6,4.5h1.4v-7.4h-1.7V16l-3.7-4.5h-1.4v7.4h1.7V14.4z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M82.4,18.9h1.7v-6h2.4v-1.4H80v1.4h2.4V18.9z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M93,17.5h-4v-1.7h3.4v-1.3H89v-1.6h3.9v-1.4h-5.6v7.4H93V17.5z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M96.1,16.8h1.5c0,0,0,0,0.1,0l1.4,2.1h1.8l-1.6-2.4c0,0,0,0,0,0c0.5-0.2,0.8-0.5,1.1-0.9 c0.3-0.4,0.4-0.9,0.4-1.4c0-0.8-0.3-1.5-0.9-1.9s-1.4-0.7-2.4-0.7h-3.1v7.4h1.7L96.1,16.8L96.1,16.8z M98.6,13.2 c0.3,0.2,0.4,0.5,0.4,0.9s-0.1,0.7-0.4,0.9c-0.3,0.2-0.7,0.3-1.2,0.3h-1.4v-2.6h1.4C98,12.9,98.4,13,98.6,13.2z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M103.8,14.4l3.6,4.5h1.4v-7.4h-1.7V16l-3.7-4.5h-1.4v7.4h1.7V14.4z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M112,17.3h3.4l0.7,1.6h1.8l-3.3-7.4h-1.7l-3.3,7.4h1.7L112,17.3z M113.7,13.2l1.2,2.8h-2.3L113.7,13.2 L113.7,13.2z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M119.8,18.9h1.7v-6h2.3v-1.4h-6.4v1.4h2.4V18.9z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M124.7,11.5h1.7v7.4h-1.7V11.5z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M134.6,12.5c-0.4-0.3-0.8-0.6-1.3-0.8c-0.5-0.2-1-0.3-1.6-0.3c-0.6,0-1.1,0.1-1.6,0.3 c-0.5,0.2-0.9,0.5-1.3,0.8c-0.4,0.3-0.6,0.7-0.8,1.2c-0.2,0.5-0.3,1-0.3,1.5s0.1,1.1,0.3,1.5c0.2,0.5,0.5,0.9,0.8,1.2 c0.4,0.3,0.8,0.6,1.3,0.8c0.5,0.2,1,0.3,1.6,0.3s1.1-0.1,1.6-0.3c0.5-0.2,0.9-0.4,1.3-0.8c0.4-0.3,0.6-0.7,0.8-1.2 c0.2-0.5,0.3-1,0.3-1.5s-0.1-1.1-0.3-1.5C135.3,13.2,135,12.8,134.6,12.5L134.6,12.5z M133.9,16.2c-0.1,0.3-0.3,0.5-0.5,0.7 s-0.5,0.4-0.7,0.5c-0.3,0.1-0.6,0.2-0.9,0.2s-0.6-0.1-0.9-0.2c-0.3-0.1-0.5-0.3-0.7-0.5c-0.2-0.2-0.4-0.5-0.5-0.7 c-0.1-0.3-0.2-0.6-0.2-1c0-0.4,0.1-0.7,0.2-1c0.1-0.3,0.3-0.5,0.5-0.8s0.4-0.4,0.7-0.5c0.3-0.1,0.6-0.2,0.9-0.2s0.6,0.1,0.9,0.2 c0.3,0.1,0.5,0.3,0.7,0.5c0.2,0.2,0.4,0.5,0.5,0.8s0.2,0.6,0.2,1C134,15.6,134,15.9,133.9,16.2z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M142.1,16l-3.6-4.5H137v7.4h1.7v-4.5l3.7,4.5h1.4v-7.4h-1.7V16z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M147.8,11.5l-3.3,7.4h1.7l0.7-1.6h3.4l0.7,1.6h1.8l-3.3-7.4H147.8z M147.5,16l1.2-2.8l1.2,2.8H147.5L147.5,16z "
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M155.3,17.5v-6h-1.7v7.4h5.4v-1.4H155.3z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M70.6,29.5h1.5c0.7,0,1.2-0.1,1.7-0.3c0.5-0.2,0.8-0.5,1.1-0.9c0.3-0.4,0.4-0.9,0.4-1.4s-0.1-1-0.4-1.4 c-0.3-0.4-0.6-0.7-1.1-0.9c-0.5-0.2-1-0.3-1.7-0.3h-3.2v7.4h1.7V29.5z M73.2,25.9c0.3,0.2,0.4,0.5,0.4,0.9s-0.1,0.7-0.4,0.9 c-0.3,0.2-0.7,0.3-1.2,0.3h-1.4v-2.6H72C72.5,25.5,72.9,25.6,73.2,25.9z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M78.4,24.1l-3.3,7.4h1.7l0.7-1.6H81l0.7,1.6h1.8l-3.3-7.4H78.4z M78.1,28.6l1.2-2.8l1.2,2.8H78.1L78.1,28.6z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M87.2,31.5v-2.6l2.8-4.7h-1.7l-2,3.3l-2-3.3h-1.8l2.9,4.7v2.6H87.2z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M94.8,28.7L92,24.1h-1.4v7.4h1.6v-4.3l2.2,3.6h0.8l2.2-3.6l0,4.4h1.6v-7.4h-1.4L94.8,28.7z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M106.2,25.5v-1.4h-5.6v7.4h5.7v-1.4h-4v-1.7h3.4v-1.3h-3.4v-1.6H106.2z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M107.7,31.5h1.7V27l3.7,4.5h1.4v-7.4h-1.7v4.5l-3.7-4.5h-1.4V31.5z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M121.7,24.1h-6.4v1.4h2.4v6h1.7v-6h2.3V24.1z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M73.8,37.1c-0.5-0.2-1-0.3-1.7-0.3h-3.2v7.4h1.7v-2h1.5c0.7,0,1.2-0.1,1.7-0.3c0.5-0.2,0.8-0.5,1.1-0.9 c0.3-0.4,0.4-0.9,0.4-1.4c0-0.6-0.1-1-0.4-1.4C74.7,37.6,74.3,37.3,73.8,37.1z M73.2,40.4c-0.3,0.2-0.7,0.3-1.2,0.3h-1.4v-2.6H72 c0.5,0,0.9,0.1,1.2,0.3c0.3,0.2,0.4,0.5,0.4,0.9S73.5,40.1,73.2,40.4z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M78.2,36.8h-1.7v7.4h5.4v-1.4h-3.7V36.8z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M85.2,36.8l-3.3,7.4h1.7l0.7-1.6h3.4l0.7,1.6h1.8l-3.3-7.4H85.2z M84.9,41.3l1.2-2.8l1.2,2.8H84.9L84.9,41.3z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M89.7,38.2h2.3v6h1.7v-6h2.4v-1.4h-6.4V38.2z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M97,44.1h1.7v-2.7h3.4v-1.4h-3.4v-1.9h3.8v-1.4H97V44.1z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M110.1,37.7c-0.4-0.3-0.8-0.6-1.3-0.8c-0.5-0.2-1-0.3-1.6-0.3s-1.1,0.1-1.6,0.3c-0.5,0.2-0.9,0.5-1.3,0.8 c-0.4,0.3-0.6,0.8-0.8,1.2c-0.2,0.5-0.3,1-0.3,1.5c0,0.5,0.1,1.1,0.3,1.5c0.2,0.5,0.5,0.9,0.8,1.2c0.4,0.3,0.8,0.6,1.3,0.8 c0.5,0.2,1,0.3,1.6,0.3s1.1-0.1,1.6-0.3c0.5-0.2,0.9-0.5,1.3-0.8c0.4-0.3,0.6-0.7,0.8-1.2c0.2-0.5,0.3-1,0.3-1.5 c0-0.5-0.1-1.1-0.3-1.5C110.8,38.4,110.5,38,110.1,37.7L110.1,37.7z M109.4,41.4c-0.1,0.3-0.3,0.5-0.5,0.8 c-0.2,0.2-0.4,0.4-0.7,0.5s-0.6,0.2-0.9,0.2c-0.3,0-0.6-0.1-0.9-0.2s-0.5-0.3-0.7-0.5c-0.2-0.2-0.4-0.5-0.5-0.8s-0.2-0.6-0.2-1 c0-0.4,0.1-0.7,0.2-1c0.1-0.3,0.3-0.5,0.5-0.7c0.2-0.2,0.5-0.4,0.7-0.5c0.3-0.1,0.6-0.2,0.9-0.2c0.3,0,0.6,0.1,0.9,0.2 c0.3,0.1,0.5,0.3,0.7,0.5s0.4,0.5,0.5,0.7c0.1,0.3,0.2,0.6,0.2,1C109.5,40.8,109.5,41.1,109.4,41.4z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M117.4,41.8c0.5-0.2,0.8-0.5,1.1-0.9c0.3-0.4,0.4-0.9,0.4-1.4c0-0.8-0.3-1.5-0.9-1.9c-0.6-0.5-1.4-0.7-2.4-0.7 h-3.1v7.4h1.7v-2.1h1.5c0,0,0.1,0,0.1,0l1.4,2.1h1.8L117.4,41.8C117.4,41.8,117.4,41.8,117.4,41.8L117.4,41.8z M116.8,38.5 c0.3,0.2,0.4,0.5,0.4,0.9s-0.1,0.7-0.4,0.9c-0.3,0.2-0.7,0.3-1.2,0.3h-1.4v-2.6h1.4C116.1,38.2,116.5,38.3,116.8,38.5z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M124.4,41.3l-2.8-4.6h-1.4v7.4h1.6v-4.3l2.2,3.6h0.8l2.2-3.6l0,4.4h1.6v-7.4h-1.4L124.4,41.3z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLogoWide);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/logo-wide.a4cd7225faadab005e6476a925512ef3.svg";